export enum ESignDateCompletionParty {
  Sender,
  Recipient,
}
